import React, { useEffect, useState } from "react";
import { parseHtml } from "../../../utils/util";
import WOW from "wowjs";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import first_slide_video from "../../icons/shapes/first_slide_video.png";
import testimonial_bg from "../../icons/shapes/testimonial-bg.png";
import quote_icon from "../../icons/shapes/quote-icon.svg";
import quote_shape from "../../icons/shapes/quote.svg";
import { UserRoutes } from "../../../routes";

const TestimonialBlock = ({ testData, testMeta, action }) => {
  const sachIcon = `<img class=${"lightIcon"} src=${require("../../../static/user/img/sach-icon.svg").default} alt="logo" /><img class=${"darkIcon"} src=${require("../../icons/sach_small_white.svg").default} alt="logo" />`;
  const testimonialFive = testData.slice(0, 5);

  useEffect(() => {
    if (!!testimonialFive) {
      let data = testimonialFive;

      // console.log("Testimonial", action);
    }
  }, [testimonialFive]);
  //    const philosophy = (
  //     <p className="wow fadeInRight" data-wow-delay="0.2s">
  //       {PhilosphyData[0] && PhilosphyData[0].desc}
  //     </p>
  //   );
  // const [staticData, setStaticData] = useState({});
  // useEffect(() => {
  //     if (dashboardData && dashboardData.homePageData) {
  //       let data = dashboardData?.homePageData;

  //       setStaticData({ ...dashboardData });
  //       localStorage.setItem("viewMoreBtn", dashboardData?.testimonialSection?.cta?.text);
  //     }
  //   }, [dashboardData]);
  //
  return (
    <>
      <article className="testimonialsBlock position-relative">
        <img src={testimonial_bg} alt="testimonial" className="testimonialbg left darkno" />

        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12">
              <header className="mb-7 mb-md-10 mb-xl-16  text-center">
                <h2 className="text-capitalize text-center wow" data-wow-delay="0.1s">
                  <strong className="fwMedium d-block position-relative text-capitalize mb-4 wow fadeInLeft">{parseHtml(testMeta?.title.replace("__SACH_ICON__", sachIcon))}</strong>
                </h2>
                <p className="fadeInLeft wow" data-wow-delay="0.3s">
                  {parseHtml(testMeta?.content)}
                </p>
              </header>
            </div>
            <div className="col-12 col-md-12">
              <div className="wow fadeInRight" data-wow-delay=".5s">
                <img src={quote_icon} alt="quote-icon" className="testimonialSlidebg left" />

                <div className="quotesSlider">
                  {testimonialFive.length > 0 && (
                    <Swiper
                      slidesPerView={3}
                      spaceBetween={20}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      centeredSlides={true}
                      loop={true}
                      modules={[Autoplay, Pagination, Navigation]}
                      navigation={true}
                      pagination={{
                        clickable: true,
                      }}
                      height={"auto"}
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                        },
                        600: {
                          slidesPerView: 2,
                          centeredSlides: false,
                        },
                        1000: {
                          slidesPerView: 3,
                        },
                      }}
                      id="sachCommunity"
                      className="mySwiper"
                    >
                      {testimonialFive.map((testimoni, j) => {
                        return (
                          <SwiperSlide key={j}>
                            <div className="item">
                              <div className="testiBlcok">
                                {testimoni.descriptionPlain.length > 0 ? (
                                  <p>
                                    <img src={quote_shape} alt="quote" className="quote" />
                                    <Link to={UserRoutes.USER_TESTIMONIALS}>{parseHtml(testimoni.descriptionPlain.substring(0, 80))}</Link>
                                  </p>
                                ) : (
                                  <p>
                                    <img src={quote_shape} alt="quote" className="quote" /> {parseHtml(testimoni.descriptionPlain)}
                                  </p>
                                )}
                                <div className="testimInfo">
                                  <img src={testimoni.authorImg} alt="icon" />
                                  <span>{testimoni.author}</span>
                                  <i>{testimoni.designation}</i>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  )}
                </div>
                <div className="col-lg-12 text-center">
                  <Link to={UserRoutes.USER_TESTIMONIALS} className="btn btn-sach bg-sach-dark">
                    {action?.cta?.text}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default TestimonialBlock;
